import { render, staticRenderFns } from "./ModalNewConfig.vue?vue&type=template&id=2bca3b56&"
import script from "./ModalNewConfig.vue?vue&type=script&lang=js&"
export * from "./ModalNewConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports